import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
} from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'core-multiline-text',
  imports: [NgClass],
  templateUrl: './multiline-text.component.html',
  styleUrl: './multiline-text.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultilineTextComponent {
  text = input<string>('');
  lines: string[] = [];

  constructor() {
    effect(() => {
      this.lines = this.text().split('\n');
    });
  }
}
